/* LILINMOMO section-storybook-product.js — BUILD_07 PDP (spec §5.4, §5.7, §5.11, §6.4, §7).
   Batch A: parse the variant data island. Batch B: gallery (next tag + counter, swipe, lightbox,
   variant→image hook). Batch C: variant state machine — option pills (no preselection), live price,
   completeness-gated add-to-cart, quantity stepper, /cart/add.js. mount/unmount honor Dawn's
   shopify:section:load / :unload re-render contract; deferred, vanilla, no framework.

   Note: this theme has no cart drawer wired into chrome (the header cart is a link to /cart, per
   spec §1.3 the drawer is a separate BUILD_07 item). So a successful add fires `cart:updated`,
   refreshes the header count bubble, and shows a transient "Added"; a dormant feature-detected
   drawer hook will open a <cart-drawer>/<cart-notification> the moment that item ships. */

(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var EMDASH = '—';
  var CHECK = '✓';

  // Shopify's classic money-format algorithm (Shopify.formatMoney), vanilla — this theme has no
  // client-side money formatter of its own, so quantity-scaled totals need one.
  function formatMoney(cents, format) {
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function withDelimiters(number, precision, thousands, decimal) {
      precision = (typeof precision === 'undefined') ? 2 : precision;
      thousands = (typeof thousands === 'undefined') ? ',' : thousands;
      decimal = (typeof decimal === 'undefined') ? '.' : decimal;

      if (isNaN(number) || number == null) return '0';

      number = (number / 100).toFixed(precision);

      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';

      return dollars + centsPart;
    }

    var match = formatString.match(placeholderRegex);
    var token = match ? match[1] : 'amount';
    var value;
    switch (token) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = withDelimiters(cents, 2);
    }

    return match ? formatString.replace(placeholderRegex, value) : (formatString + value);
  }

  function mount(root) {
    // Variant data island.
    var data = null;
    var island = root.querySelector('[data-pdp-data]');
    if (island) {
      try { data = JSON.parse(island.textContent); } catch (e) { data = null; }
    }
    root._pdpData = data;

    mountGallery(root);
    mountBuy(root, data);
  }

  /* ── Gallery (Batch B) ─────────────────────────────────────────────────────────────── */
  function mountGallery(root) {
    var track = root.querySelector('[data-pdp-track]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-pdp-slide]')) : [];
    var nextBtn = root.querySelector('[data-pdp-next]');
    var prevBtn = root.querySelector('[data-pdp-prev]');
    var countEl = root.querySelector('[data-pdp-count]');

    function activeIndex() {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('is-active')) return i;
      }
      return 0;
    }
    function setActive(mediaId, scroll) {
      var id = String(mediaId);
      var target = null, idx = -1;
      slides.forEach(function (s, i) {
        var on = s.getAttribute('data-media-id') === id;
        s.classList.toggle('is-active', on);
        if (on) { target = s; idx = i; }
      });
      if (countEl && idx >= 0) countEl.textContent = (idx + 1) + ' / ' + slides.length;
      if (scroll && target && track) {
        root._pdpProgrammatic = Date.now();
        track.scrollTo({ left: target.offsetLeft, behavior: REDUCED.matches ? 'auto' : 'smooth' });
      }
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (!slides.length) return;
        var next = (activeIndex() + 1) % slides.length;
        setActive(slides[next].getAttribute('data-media-id'), true);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (!slides.length) return;
        var prev = (activeIndex() - 1 + slides.length) % slides.length;
        setActive(slides[prev].getAttribute('data-media-id'), true);
      });
    }

    if (track) {
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          if (root._pdpProgrammatic && Date.now() - root._pdpProgrammatic < 600) return;
          var center = track.scrollLeft + track.clientWidth / 2;
          var nearest = slides[0], best = Infinity;
          slides.forEach(function (s) {
            var d = Math.abs((s.offsetLeft + s.offsetWidth / 2) - center);
            if (d < best) { best = d; nearest = s; }
          });
          if (nearest) setActive(nearest.getAttribute('data-media-id'), false);
        });
      }, { passive: true });
    }

    root._pdpGallery = {
      showMediaId: function (mediaId) { if (mediaId != null) setActive(mediaId, true); }
    };

    // Zoom lightbox.
    var lightbox = root.querySelector('[data-pdp-lightbox]');
    if (lightbox) {
      var lbImg = lightbox.querySelector('[data-pdp-lightbox-img]');
      var lbClose = lightbox.querySelector('[data-pdp-lightbox-close]');
      var lastFocus = null;

      function activeSlide() {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].classList.contains('is-active')) return slides[i];
        }
        return slides[0] || null;
      }
      function paint() {
        var s = activeSlide();
        if (!s) return;
        var img = s.querySelector('img');
        lbImg.setAttribute('src', s.getAttribute('data-zoom') || (img && img.currentSrc) || '');
        lbImg.setAttribute('alt', img ? (img.getAttribute('alt') || '') : '');
      }
      function step(delta) {
        if (!slides.length) return;
        var next = (activeIndex() + delta + slides.length) % slides.length;
        setActive(slides[next].getAttribute('data-media-id'), true);
        paint();
      }
      function onKey(e) {
        if (e.key === 'Escape') { e.preventDefault(); close(); }
        else if (e.key === 'Tab') { e.preventDefault(); lbClose.focus(); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      }
      function open() {
        var s = activeSlide();
        if (!s) return;
        paint();
        lastFocus = document.activeElement;
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
        lbClose.focus();
        document.addEventListener('keydown', onKey, true);
      }
      function close() {
        lightbox.hidden = true;
        document.body.style.overflow = '';
        document.removeEventListener('keydown', onKey, true);
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      root.querySelectorAll('[data-pdp-zoom]').forEach(function (z) { z.addEventListener('click', open); });
      lbClose.addEventListener('click', close);
      var lbPrev = lightbox.querySelector('[data-pdp-lightbox-prev]');
      var lbNext = lightbox.querySelector('[data-pdp-lightbox-next]');
      if (lbPrev) lbPrev.addEventListener('click', function () { step(-1); });
      if (lbNext) lbNext.addEventListener('click', function () { step(1); });
      lightbox.addEventListener('click', function (e) { if (e.target === lightbox) close(); });
      root._pdpLightbox = { close: close };
    }
  }

  /* ── Variant state machine + buy area (Batch C) ────────────────────────────────────── */
  function mountBuy(root, data) {
    var form = root.querySelector('[data-pdp-form]');
    if (!form || !data) return;

    var variants = data.variants || [];
    var groups = Array.prototype.slice.call(form.querySelectorAll('[data-pdp-option-group]'));
    var idInput = form.querySelector('[data-pdp-variant-id]');
    var atc = form.querySelector('[data-pdp-atc]');
    var atcLabel = form.querySelector('[data-pdp-atc-label]');
    var priceNow = root.querySelector('[data-pdp-price-now]');
    var priceWas = root.querySelector('[data-pdp-price-was]');
    var priceFrom = root.querySelector('[data-pdp-price-from]');
    var qtyInput = form.querySelector('[data-pdp-qty]');
    var persInput = form.querySelector('[data-pdp-personalization-input]');
    var persError = form.querySelector('[data-pdp-personalization-error]');
    var persCount = form.querySelector('[data-pdp-personalization-count]');

    // No preselected defaults — every option starts unchosen (owner decision). The shopper must
    // actively pick every option before add-to-cart enables. Gating depends only on completeness
    // (products are made-to-order — no availability/sold-out logic).
    var selected = groups.map(function () { return null; });

    function matches(variant, values) {
      var vo = variant.options;
      for (var j = 0; j < values.length; j++) {
        if (values[j] != null && vo[j] !== values[j]) return false;
      }
      return true;
    }
    // Data-driven, not option-name-based: whatever the current (possibly partial) selection is,
    // if every matching variant shares one price, that price is already resolved (e.g. the sizing
    // option is picked but a cosmetic option like Color isn't yet). If matches span more than one
    // price, it's genuinely ambiguous and null is returned.
    function resolvePartialPrice() {
      var matching = variants.filter(function (v) { return matches(v, selected); });
      if (!matching.length) return null;
      var price = matching[0].price;
      for (var i = 1; i < matching.length; i++) {
        if (matching[i].price !== price) return null;
      }
      return matching[0];
    }
    function resolve() {
      if (groups.length === 0) {
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].id === data.currentVariantId) return variants[i];
        }
        return variants[0] || null;
      }
      if (selected.indexOf(null) !== -1) return null; // incomplete
      for (var k = 0; k < variants.length; k++) {
        if (matches(variants[k], selected)) return variants[k];
      }
      return null;
    }

    function update() {
      var v = resolve();
      var complete = (groups.length === 0) || (selected.indexOf(null) === -1 && v != null);

      // Price line: show the resolved price the moment enough of the selection determines it,
      // even if a still-unpicked cosmetic option (e.g. Color) leaves the exact variant unknown.
      // Always unit price -- quantity never affects the price line, only the ATC button total.
      var priceInfo = complete ? v : resolvePartialPrice();
      if (priceInfo) {
        if (priceFrom) priceFrom.hidden = true;
        if (priceNow) priceNow.textContent = priceInfo.priceMoney;
        if (priceWas) {
          if (priceInfo.compareAtPrice && priceInfo.compareAtPrice > priceInfo.price && priceInfo.compareAtMoney) {
            priceWas.textContent = priceInfo.compareAtMoney; priceWas.hidden = false;
          } else { priceWas.hidden = true; }
        }
      } else {
        if (priceFrom) priceFrom.hidden = false;
        if (priceNow && data.priceMinMoney) priceNow.textContent = data.priceMinMoney;
        if (priceWas) priceWas.hidden = true;
      }

      // Actionability: unchanged -- still gated on full completeness, since /cart/add needs one
      // exact variant id regardless of whether the price is already knowable.
      if (complete && v) {
        if (idInput) idInput.value = v.id;
        if (v.featuredMediaId != null && root._pdpGallery) root._pdpGallery.showMediaId(v.featuredMediaId);

        atcLabel.textContent = 'Add to cart ' + EMDASH + ' ' + formatMoney(v.price * qty(), data.moneyFormat);
        atc.disabled = false;
        atc.setAttribute('aria-disabled', 'false');
        atc.classList.remove('is-disabled');
      } else {
        if (idInput) idInput.value = '';

        atcLabel.textContent = 'Choose your options';
        atc.disabled = true;
        atc.setAttribute('aria-disabled', 'true');
        atc.classList.add('is-disabled');
      }
    }

    // Option controls — single-select per group. Selector is class-agnostic ([data-pdp-value]) so
    // pills (Size) and swatches (Colour, Batch D) drive the same machine.
    groups.forEach(function (g, gi) {
      Array.prototype.forEach.call(g.querySelectorAll('[data-pdp-value]'), function (p) {
        p.addEventListener('click', function () {
          Array.prototype.forEach.call(g.querySelectorAll('[data-pdp-value]'), function (o) {
            var on = o === p;
            o.classList.toggle('is-selected', on);
            o.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          selected[gi] = p.getAttribute('data-pdp-value');
          // Live script caption echo (colour card only; no-op for other groups).
          var nameEl = g.querySelector('[data-pdp-color-name]');
          if (nameEl) nameEl.textContent = p.getAttribute('data-pdp-value');
          update();
        });
      });
    });

    // Colour preview expand/collapse — extras stay in the DOM (CSS-hidden); selection unaffected.
    Array.prototype.forEach.call(form.querySelectorAll('[data-pdp-color-more]'), function (btn) {
      var card = btn.closest('.pdp-option--color');
      var label = btn.querySelector('[data-pdp-color-more-label]');
      if (!card) return;
      btn.addEventListener('click', function () {
        var expanded = card.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (label) label.textContent = expanded ? 'show less' : 'click to see more';
      });
    });

    // Quantity stepper.
    function qty() { var n = parseInt(qtyInput && qtyInput.value, 10); return (isNaN(n) || n < 1) ? 1 : n; }
    var dec = form.querySelector('[data-pdp-qty-dec]');
    var inc = form.querySelector('[data-pdp-qty-inc]');
    if (dec) dec.addEventListener('click', function () { qtyInput.value = Math.max(1, qty() - 1); update(); });
    if (inc) inc.addEventListener('click', function () { qtyInput.value = qty() + 1; update(); });
    if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = qty(); update(); });

    if (persInput && persCount) {
      persInput.addEventListener('input', function () {
        persCount.textContent = persInput.value.length + '/256';
        if (persInput.value.trim() && persError) persError.hidden = true;
      });
    }

    // Add to cart.
    function flash(text, success) {
      if (atcLabel) atcLabel.textContent = text;
      atc.classList.toggle('is-added', !!success);
      clearTimeout(root._pdpFlash);
      root._pdpFlash = setTimeout(function () { atc.classList.remove('is-added'); update(); }, 1800);
    }
    function refreshCartCount() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var el = document.querySelector('.cart-count');
          if (el) { el.textContent = cart.item_count; }
          else if (cart.item_count > 0) {
            var btn = document.querySelector('.site-header__cart-btn');
            if (btn) {
              var s = document.createElement('span');
              s.className = 'cart-count'; s.setAttribute('aria-hidden', 'true');
              s.textContent = cart.item_count; btn.appendChild(s);
            }
          }
        })
        .catch(function () {});
    }
    function addToCart(id, quantity, properties) {
      atc.classList.add('is-loading');
      var item = { id: id, quantity: quantity };
      if (properties) item.properties = properties;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          atc.classList.remove('is-loading');
          if (!res.ok || res.body.status) { flash('Could not add', false); return; }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'pdp' } }));
          // The /cart/add.js response body for the { items: [...] } POST form is always
          // { items: [...] } (even for a single item) — read the added line from there,
          // not the DOM, so the pushed values match what Shopify actually added.
          if (window.lmDL) {
            var line = res.body.items && res.body.items[0];
            if (line) {
              var atcItem = {
                item_id: line.sku || String(line.variant_id),
                item_name: line.product_title,
                item_brand: 'LILINMOMO',
                item_category: line.product_type,
                price: window.lmDL.money(line.price),
                quantity: line.quantity
              };
              if (line.variant_title && line.variant_title !== 'Default Title') atcItem.item_variant = line.variant_title;
              window.lmDL.push('add_to_cart', {
                currency: window.lmDL.currency,
                value: window.lmDL.money(line.price) * line.quantity,
                items: [atcItem]
              });
            }
          }
          // Dormant drawer hook — opens a cart drawer/notification when this theme wires one.
          var cart = document.querySelector('cart-drawer, cart-notification');
          if (cart && typeof cart.open === 'function') { try { cart.open(); } catch (e) {} }
          refreshCartCount();
          flash('Added ' + CHECK, true);
        })
        .catch(function () { atc.classList.remove('is-loading'); flash('Could not add', false); });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atc.disabled) return;
      var v = resolve();
      if (!v) return;
      var props = null;
      if (persInput) {
        var pv = persInput.value.trim();
        if (!pv) {
          if (persError) persError.hidden = false;
          persInput.focus();
          return;
        }
        props = { 'Personalization': pv };
      }
      addToCart(v.id, qty(), props);
    });

    update(); // initial state (re-affirms the server-rendered selection)
  }

  function unmount(root) {
    if (root._pdpLightbox) { root._pdpLightbox.close(); root._pdpLightbox = null; }
    if (root._pdpFlash) { clearTimeout(root._pdpFlash); root._pdpFlash = null; }
    root._pdpData = null;
    root._pdpGallery = null;
  }

  // First paint
  document.querySelectorAll('.section-storybook-product').forEach(mount);

  // Theme editor re-render contract
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.classList.contains('section-storybook-product')) mount(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target.classList.contains('section-storybook-product')) unmount(e.target);
  });
})();
